import { AutogenModelEdiRequiredField, AutogenRowEdiRequiredField } from "./autogen/AutogenModelEdiRequiredField";

export class ModelEdiRequiredField extends AutogenModelEdiRequiredField<RowEdiRequiredField> {
	constructor() {
		super(RowEdiRequiredField);
	}
}

export class RowEdiRequiredField extends AutogenRowEdiRequiredField {
}